import { isNil, isString } from "lodash";
import authentication from "@irati/auth";
export var formatCurrency = function (_a) {
    var _b = _a.isCents, isCents = _b === void 0 ? true : _b, value = _a.value, _c = _a.currencyCode, currencyCode = _c === void 0 ? authentication.defaultUserCurrency() : _c, _d = _a.locale, locale = _d === void 0 ? authentication.userLocale() : _d, _e = _a.trimZerosFromWholeNumber, trimZerosFromWholeNumber = _e === void 0 ? true : _e;
    if (isNil(value)) {
        var symbol = formatForLocale(currencyCode, locale, 1, trimZerosFromWholeNumber);
        return symbol.replace(/[0-9,. ]/g, "");
    }
    var normalisedValue = getNormalisedValue(isCents, currencyCode, value);
    return formatForLocale(currencyCode, locale, normalisedValue, trimZerosFromWholeNumber);
};
/**
 * @description: Turn a cent currency value into the full currency value
 */
export function getNormalisedValue(isCents, currency, value) {
    if (currency === void 0) { currency = authentication.defaultUserCurrency(); }
    if (isCents) {
        switch (currency) {
            // add non-cent based currencies here
            default:
                return parseValue(value) / 100;
        }
    }
    return parseValue(value);
}
/**
 * @description: Turn a float currency value to a basic value (cent)
 */
export function getCentValue(currency, value) {
    switch (currency) {
        // add non-cent based currencts here
        default:
            return Math.round(parseValue(value) * 100);
    }
}
function parseValue(value) {
    if (isString(value)) {
        return parseFloat(value);
    }
    return value;
}
function formatForLocale(currency, locale, value, trimZerosFromWholeNumber) {
    var format = currency ? { style: "currency", currency: currency } : undefined;
    var text = new Intl.NumberFormat(locale, format).format(value);
    if (trimZerosFromWholeNumber) {
        text = text.replace(/[,.]00([ ].)?$/, "$1");
    }
    return text;
}
